import React from "react";
import styles from "./creatableItem.module.scss";
import Icon from "features/shared/components/icons/Icon";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type Props = {
  text: string;
  code: string;
  actionIcon?: IconProp;
  onActionClick?: (code: string) => void;
};

const CreatableItem = ({
  text,
  code,
  actionIcon = "times",
  onActionClick,
}: Props) => {
  // render
  return (
    <div className={styles.item}>
      <div className="row no-gutters align-items-center">
        <div className="col">{text}</div>
        {onActionClick && (
          <div className="col-auto pl-3">
            <span
              role="button"
              className={styles.icon}
              onClick={() => onActionClick(code)}
            >
              <Icon icon={actionIcon} />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CreatableItem;
